export default "__VITE_ASSET___nZXczur__";